"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketCorsInput_1 = require("./GetBucketCorsInput");
var GetBucketCorsOutput_1 = require("./GetBucketCorsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketCors = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketCors",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?cors"
    },
    input: {
        shape: GetBucketCorsInput_1.GetBucketCorsInput
    },
    output: {
        shape: GetBucketCorsOutput_1.GetBucketCorsOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketCors.js.map